import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FormDirtyService {

  constructor() { }

  private formDirty: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  formDirty$ = this.formDirty.asObservable();

  formIsDirty() {
    this.formDirty.next(true);
  }

  formIsClean() {
    this.formDirty.next(false);
  }
}
